<template>
  <div>
    <v-data-table :headers="headers" :items="receipts" sort-by="purchasedAt" sort-desc :item-class="getRowClass"
      class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-toolbar-title>Sale Receipts</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-col cols="3" class="pt-0 pb-0">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details
                @keydown.enter.prevent></v-text-field>

            </v-col>
          </v-row>
        </v-toolbar>
      </template>
      <template v-slot:[`header.productInfo`]>
        <div class="product-info-header">
          <div class="main-header">Product Details</div>
          <div class="sub-header-row">
            <div class="sub-column-header product-name">Product Name</div>
            <div class="sub-column-header quantity">Quantity</div>
          </div>
        </div>
      </template>
      <template v-slot:[`item.productInfo`]="{ item }">
        <div class="product-info-data">
          <div class="sub-column-data product-name">
            <div v-for="(product, index) in item.products" :key="index" class="product-item">
              {{ product.name }}
            </div>
          </div>
          <div class="sub-column-data quantity">
            <div v-for="(product, index) in item.products" :key="index" class="product-item">
              {{ product.quantity }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:[`item.amountReceived`]="{ item }">
        €{{ item.amountReceived.toFixed(2) }}
      </template>
      <template v-slot:[`item.changeDue`]="{ item }">
        €{{ item.changeDue.toFixed(2) }}
      </template>

      <template v-slot:[`item.booksCancelled`]="{ item }">
        <v-btn :disabled="item.booksCancelled" :color="item.booksCancelled ? 'grey' : 'red'" icon
          @click="openCancelDialog(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <v-dialog v-model="cancelDialog" max-width="500px">
        <v-card>
          <v-card-title class="headline">Cancel Receipt Books</v-card-title>
          <v-card-text>
            All the books associated with this receipt will be cancelled. Are you sure?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="cancelDialog = false">No</v-btn>
            <v-btn color="red" text @click="confirmCancel">Yes, Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-data-table>
    <v-dialog v-model="cancelDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Cancel Receipt Books</v-card-title>
        <v-card-text>
          All the books associated with this receipt will be cancelled. Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDialog = false">No</v-btn>
          <v-btn color="red" text @click="confirmCancel">Yes, Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SaleReceitTable",

  data: () => ({
    search: "",
    headers: [
      { text: "Receipt ID", value: "id", align: "start" },
      { text: "Session Title", value: "sessionTitle" },
      { text: "Session Date", value: "sessionDate" },
      { text: "Session Time", value: "sessionTime" },
      { text: "Purchased At", value: "purchasedAt" },
      { text: "Purchase Time", value: "purchasedTime" },
      { text: "Amount Received", value: "amountReceived" },
      { text: "Change Due", value: "changeDue" },
      {
        text: "Product Details",
        value: "productInfo",
        sortable: false,
        width: "30%",
      },

      { text: "Cancel Books", value: "booksCancelled", sortable: false },
    ],
    cancelDialog: false,
    selectedReceipt: null,
  }),

  computed: {
    ...mapGetters(["getReceipts"]),
    receipts() {
      return this.getReceipts.map((r) => {
        const [year, month, day, hour, minute] = r.dateCreated;
        const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute));
        const localTime = `${String(utcDate.getHours()).padStart(2, '0')}:${String(utcDate.getMinutes()).padStart(2, '0')}`;
        return {
          id: r.id,
          purchasedAt: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
          purchasedTime: localTime,
          amountReceived: parseFloat(r.amountReceived.replace(/[€,]/g, "")),
          changeDue: parseFloat(r.changeDue.replace(/[€,]/g, "")),
          products: r.products?.map((p) => ({
            name: p.productTitle || "N/A",
            quantity: p.quantity,
          })) || [],
          searchableProductNames: r.products?.map(p => p.productTitle?.toLowerCase()).join(", ") || "",
          booksCancelled: r.booksCancelled,
          sessionTitle: r.schedule?.title || "N/A",
          sessionDate: r.schedule?.date || "N/A",

          sessionTime: this.formatUTCToLocalTime(r.schedule?.time),
        };
      }).filter(receipt => {
        if (!this.search) return true;
        const s = this.search.toLowerCase();
        return (
          receipt.id.toLowerCase().includes(s) ||
          receipt.purchasedAt.includes(s) ||
          receipt.purchasedTime.includes(s) ||
          receipt.searchableProductNames.includes(s)
        );
      });
    },

  },

  methods: {
    ...mapActions(["fetchAllReceipts", "cancelAllBooksOfReceipt"]),
    openCancelDialog(receipt) {
      this.selectedReceipt = receipt;
      this.cancelDialog = true;
    },
    async confirmCancel() {
      if (!this.selectedReceipt) return;
      try {
        await this.cancelAllBooksOfReceipt(this.selectedReceipt.id);
        this.cancelDialog = false;
        this.fetchAllReceipts(); // Refresh the list
      } catch (error) {
        console.error("Failed to cancel books:", error);
      }
    },
    getRowClass(item) {
      return item.booksCancelled ? 'cancelled-row' : '';
    },
    formatUTCToLocalTime(timeArr) {
      if (!Array.isArray(timeArr)) return timeArr;
      const [hour, minute] = timeArr;
      const now = new Date();
      const utcDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute));
      return `${String(utcDate.getHours()).padStart(2, '0')}:${String(utcDate.getMinutes()).padStart(2, '0')}`;
    }

  },

  mounted() {
    this.fetchAllReceipts();
  },
};
</script>



<style scoped>
.v-data-table {
  width: 100%;
}

.product-info-header {
  display: flex;
  flex-direction: column;
}

.main-header {
  font-weight: bold;
  font-size: 0.875rem;
  padding: 8px 4px;
  text-align: left;
}

.sub-header-row {
  display: flex;
  border-top: 1px solid #e0e0e0;
  background-color: #f5f5f5;
}

.sub-column-header {
  padding: 4px;
  font-weight: bold;
  font-size: 0.75rem;
  text-align: left;
}

.product-info-data {
  display: flex;
}

.sub-column-data {
  padding: 4px;
  font-size: 0.875rem;
  text-align: left;
}

.product-name {
  flex: 2;
}

.quantity {
  flex: 1;
  text-align: center;
}

.product-item {
  padding: 2px 0;
  min-height: 20px;
}

.cancelled-row {
  text-align: center;
  text-decoration: line-through;
  opacity: 0.6;
}
</style>